<template>
  <DialogFull :data="dialogSettings" @close="close" noOverflow>
    <template v-slot:dialog.body>
      <div class="container my-6">
        <h2 class="my-2">
          Are you sure you want to archive this organisation unit?
        </h2>
        <p>
          Archiving the {{ unit && unit.name }} organisation unit may effect
          other parts of the system
        </p>
        <div v-if="hasChildren">
          <strong>
            The following child organiation units will also be archived
          </strong>
          <OrganisationUnitItem
            toggledByFilter
            viewOnly
            v-for="child in children"
            :key="child.id"
            :unit="child"
          />
        </div>
      </div>
    </template>
    <template v-slot:dialog.action>
      <ErrorButton @click="handleSubmit" :loading="isLoading">
        Archive
      </ErrorButton>
    </template>
  </DialogFull>
</template>

<script>
import ErrorButton from "@/components/common/Button/ErrorButton";
import { ORGANISATION_UNITS_NAMESPACE } from "@/store/modules/organisations/organisation-units";
import { createNamespacedHelpers } from "vuex";
import { ARCHIVE_ORGANISATION_UNIT } from "@/store/modules/organisations/organisation-units/actions";
import DialogFull from "@/components/common/DialogFull";
import OrganisationUnitItem from "@/views/settings/Organisation/Units/OrganisationUnitItem";
import { isEmpty } from "lodash";

const { mapActions } = createNamespacedHelpers(ORGANISATION_UNITS_NAMESPACE);

export default {
  name: "ArchiveUnitDialog",
  components: { ErrorButton, DialogFull, OrganisationUnitItem },
  props: {
    unit: {
      type: Object,
      require: true
    },
    isOpen: Boolean
  },
  data() {
    return {
      isLoading: false,
      dialogSettings: {
        dialog: this.isOpen,
        title: "Archive Organisation Unit"
      }
    };
  },
  computed: {
    children() {
      return this.unit ? this.unit.organisationUnits : [];
    },
    hasChildren() {
      return !isEmpty(this.children);
    }
  },
  methods: {
    ...mapActions({
      archiveOrganisationUnit: ARCHIVE_ORGANISATION_UNIT
    }),
    close() {
      this.$emit("close");
    },
    async handleSubmit() {
      this.isLoading = true;
      await this.archiveOrganisationUnit(this.unit.id);
      this.$router.push("/settings/organisation/archived");
      this.close();
      this.isLoading = false;
    }
  }
};
</script>

<style scoped></style>
